import { config } from '@uhg-abyss/web/tools/config';

import { ConstantsLagoon } from '../../common/ConstantsLagoon';
import { useCustomQuery } from '../useCustomQuery';
import { useFeatureFlag } from '../useFeatureFlag';
import GetUserLocation from './UserLocation.graphql';

export const useUserLocation = (options) => {
  const [isAWSLocationSearchEnabled] = useFeatureFlag([
    ConstantsLagoon.FEATURE_FLAGS.SWITCH_TO_AWS_LOCATION_SEARCH,
  ]);

  const [queryResult, queryAction] = useCustomQuery(GetUserLocation, {
    ...options,
    url: config('GRAPHQL_API_URL'),
    accessor: 'userLocation',
  });

  const parsedResult = (params) =>
    queryAction({
      ...params,
      variables: {
        ...params?.variables,
        isAWSLocationSearchEnabled,
      },
    });

  return [queryResult, parsedResult];
};
